module.exports = "<div id=\"m-primeiro-acesso\" class=\"modal bottom-sheet center-modal banner-pa\">\n  <div class=\"modal-content tac p0\">\n    <div>\n      <a class=\"btn waves-effect waves-teal btn-back ico-close\" (click)=\"fechar()\"></a>\n      <img src=\"data:image/png;base64,{{imagem}}\"/>\n    </div>\n    \n  </div>\n</div>\n  \n"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/primeiro-acesso/primeiro-acesso.component.html
// module id = ../../../../../src/app/componentes/primeiro-acesso/primeiro-acesso.component.html
// module chunks = main